import { render, staticRenderFns } from "./JsonContentBlockForm.vue?vue&type=template&id=ffd60fa6&"
import script from "./JsonContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./JsonContentBlockForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports